module.exports = __webpack_public_path__ + "img/VWD.c5d04170.webp";